export default "__VITE_ASSET__Bi5nnADR__"